import { Button, Modal } from '@mantine/core'
import { useAtom } from '@reatom/react'
import { CloudUploadOutlined } from '@ant-design/icons'
import { orderFilesAtom } from './order-files.atom'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useDisclosure } from '@mantine/hooks'
import { OrderFilesModalContent } from './order-files-modal-content'

export function AttachFilesButton() {
  const [{ attachedFilesMap }, { reset }] = useAtom(orderFilesAtom)
  const intl = useIntl()
  const message = attachedFilesMap.size > 0
    ? `${intl.messages['externalSourceProposal.proposalFiles.labelNonEmpty']}: ${attachedFilesMap.size}`
    : `${intl.messages['externalSourceProposal.proposalFiles.labelEmpty']}`

  const [opened, { open, close }] = useDisclosure(false)

  useEffect(() => () => {
    reset()
  }, [reset])

  return (
    <>
      <Modal
        zIndex={1000}
        opened={opened}
        onClose={close}
        title={`${intl.messages['externalSourceProposal.proposalFiles.modalTitle']}`}
      >
        <OrderFilesModalContent/>
      </Modal>

      <Button
        variant='default'
        onClick={open}
        rightIcon={<CloudUploadOutlined size={18}/>}>
        {message}
      </Button>
    </>
  )
}
